import BranchReducer from "./branch";
import CityReducer from "./city";
import ConfigBranchReducer from "./config-branch";
import CustomerReducer from "./customer";
import CustomerHierarchyReducer from "./customer-hierarchy";
import TempCustomerReducer from "./customer-temp";
import CustomerTypeReducer from "./customer-type";
import DistrictReducer from "./district";
import InfoDistributionReducer from "./info-distribution";
import InventoryReducer from "./inventory";
import ItemReducer from "./item";
import ItemBrandReducer from "./item-brand";
import ItemCategoryReducer from "./item-category";
import ItemTypeReducer from "./itemtype";
import PostalCodeReducer from "./postalcode";
import ProvinceReducer from "./province";
import SetupHierarchyReducer from "./setup-hierarchy";
import SetupWarehouseReducer from "./setup-warehouse";
import StoresReducer from "./store";
import SubDistrictReducer from "./sub-district";
import SubWarehouseReducer from "./subwarehouse";
import SupplierReducer from "./supplier";
import TaxReducer from "./tax";
import UnitReducer from "./unit";
import VehicleReducer from "./vehicle";
import WarehouseReducer from "./warehouse";
import WorkCalendarReducer from "./work-calendar";

export default {
  branch: BranchReducer,
  city: CityReducer,
  customer: CustomerReducer,
  customerhierarchy: CustomerHierarchyReducer,
  customerType: CustomerTypeReducer,
  district: DistrictReducer,
  item: ItemReducer,
  inventory: InventoryReducer,
  itemType: ItemTypeReducer,
  itemBrand: ItemBrandReducer,
  itemCategory: ItemCategoryReducer,
  postalcode: PostalCodeReducer,
  province: ProvinceReducer,
  setupWarehouse: SetupWarehouseReducer,
  stores: StoresReducer,
  subDistrict: SubDistrictReducer,
  subWarehouse: SubWarehouseReducer,
  supplier: SupplierReducer,
  tax: TaxReducer,
  unit: UnitReducer,
  vehicle: VehicleReducer,
  warehouse: WarehouseReducer,
  workCalendar: WorkCalendarReducer,
  setuphierarchy: SetupHierarchyReducer,
  tempcustomer: TempCustomerReducer,
  configBranch: ConfigBranchReducer,
  infoDistribution: InfoDistributionReducer,
};
